import { isNumberUnit } from '@exodus/currency'
import lodash from 'lodash'

const { isNumber, isString } = lodash

function parseBalance({ asset, balance }) {
  const currency = asset.currency
  if (isNumberUnit(balance)) {
    if (balance.unitType.equals(currency)) {
      return balance
    }

    throw new Error(
      `Balance '${balance.toDefaultString({ unit: true })}' is not of currency ${currency.toDefaultString({ unit: true })}`
    )
  }

  if (isString(balance)) {
    return currency.parse(balance)
  }

  if (isNumber(balance)) {
    return currency.defaultUnit(balance)
  }

  throw new Error(`Cannot parse balance '${balance}' of currency ${currency}`)
}

export const parseLegacyBalances = (tokenBalances, assets) =>
  Object.fromEntries(
    Object.entries(tokenBalances || {})
      .filter(([assetName]) => assets[assetName])
      .map(([assetName, balance]) => [
        assetName,
        parseBalance({ asset: assets[assetName], balance }),
      ])
  )
